<script lang="jsx">
import PlanPropsMixin from '@/plans/mx/plan-props'
import BuyNow from './buy-now.vue'
import Add from './add.vue'

export default {
  name: 'EventServicesConfig',

  mixins: [PlanPropsMixin],

  render() {
    const props = { ...this.$props, ...this.$attrs}

    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow {...props} />
    if (this.$context.is.add2cart) return <Add {...props} />
    return null
  },
}
</script>
